import { gql } from '@apollo/client';

export const SAVE_CITY = gql`
  mutation saveCity($city: CityInput!) {
    saveCity(city: $city) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_CITIES = gql`
  mutation deleteCities($ids: [Int!]) {
    deleteCities(ids: $ids) {
      commandId
      correlationId
    }
  }
`;
